import React from 'react'
import styled from 'styled-components'

const HeroSectionView = styled.section`
  height: 100vh;
  width: 100vw;
  color: #ffffff;
  position: sticky;
  top: 0;
  left: 0;
  z-index: 10;
`

const HeroContent = styled.header`
  height: 100vh;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: center;
  padding: 0 2.25rem;
  background-color: #041E42;
  background-image: url(${props => props?.backgroundImage || 'https://placebear.com/g/1200/900'});
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
`

const Activity = styled.p`
  font-size: 28px;
  margin-bottom: .625rem;
`

const Location = styled.p`
  font-size: 19px;
  margin-bottom: 2rem;
`

const Title = styled.h1`
  font-size: 50px;
  line-height: 1;
  font-weight: bold;
`

const HeroSection = ({activity = 'Fly fishing', location='Leynavatn', title = 'Get to know our wild'}) => (
  <HeroSectionView>
    <HeroContent>
      <Activity>{activity}</Activity>
      <Location>{location}</Location>
      <Title>{title}</Title>
    </HeroContent>
  </HeroSectionView>
)

export default HeroSection